class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    // Fix for custom elements in drawers using data-module-drawers-move-me="root"
    if (this.hasBeenInitialised) {
      this.listeners.removeAll()
      this.setupListeners()
      return
    }

    super.connectedCallback()

    this.currentMode = this.isMobile() ? 'mobile' : 'desktop'

    // Snapshot the server-rendered state so mobile can restore Liquid defaults
    this.initialExpanded = this.els.trigger.elements.map(
      (triggerEl) => triggerEl.getAttribute('aria-expanded') === 'true',
    )

    this.checkMobileOnly()

    this.handleResize = this.handleResize.bind(this)
    this.listeners.add(window, 'resize', this.handleResize)
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    if (this.hasAttribute('data-mobile-only') && !this.isMobile()) {
      return
    }

    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    const currentState =
      clickedTriggerEl.getAttribute('aria-expanded') === 'true'

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl === clickedTriggerEl) {
        triggerEl.setAttribute('aria-expanded', !currentState)
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.setAttribute('aria-expanded', false)
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        contentEl.setAttribute('aria-hidden', currentState)
      } else if (this.dataset.type === 'oneopen') {
        contentEl.setAttribute('aria-hidden', true)
      }
    })
  }

  handleResize () {
    const newMode = this.isMobile() ? 'mobile' : 'desktop'

    if (newMode !== this.currentMode) {
      this.currentMode = newMode
      this.checkMobileOnly()
    }
  }

  checkMobileOnly () {
    if (this.hasAttribute('data-mobile-only')) {
      if (this.currentMode === 'desktop') {
        this.els.trigger.elements.forEach((triggerEl) => {
          triggerEl.setAttribute('aria-expanded', true)
        })
        this.els.content.elements.forEach((contentEl) => {
          contentEl.setAttribute('aria-hidden', false)
        })
      } else {
        this.els.trigger.elements.forEach((triggerEl, index) => {
          triggerEl.setAttribute('aria-expanded', this.initialExpanded[index])
        })
        this.els.content.elements.forEach((contentEl, index) => {
          contentEl.setAttribute('aria-hidden', !this.initialExpanded[index])
        })
      }
    }
  }

  isMobile () {
    return window.BAO.MediaBreakpoints.isMd === false
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
